import { render, staticRenderFns } from "./CouponManagement.vue?vue&type=template&id=37c065f7&scoped=true&"
import script from "./CouponManagement.vue?vue&type=script&lang=ts&"
export * from "./CouponManagement.vue?vue&type=script&lang=ts&"
import style0 from "./CouponManagement.vue?vue&type=style&index=0&id=37c065f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c065f7",
  null
  
)

export default component.exports